<script setup lang="ts">
import { useDestinationSelectorStore } from '@apps/main/new-desktop/core/stores/destinationSelectorStore';
import { DestinationSelectorModal } from '@apps/main/new-desktop/modules/destinationSelector';

import { BuildYourTripModalType } from '../models/buildYourTripModals';
import { useBuildYourTripModalsStore } from '../stores/buildYourTripModalsStore';

const buildYourTripModalsStore = useBuildYourTripModalsStore();
const destinationSelectorStore = useDestinationSelectorStore();
</script>

<template>
  <DestinationSelectorModal
    v-if="
      buildYourTripModalsStore.buildYourTripModalType ===
      BuildYourTripModalType.DestinationSelector
    "
    :search-text="destinationSelectorStore.searchText"
    :autocomplete-type="destinationSelectorStore.autocompleteType"
    @close-modal="buildYourTripModalsStore.closeBuildYourTripModal"
    @select-my-position="buildYourTripModalsStore.selectUserPosition"
    @change-destination="
      buildYourTripModalsStore.confirmDestinationSelectorModal
    "
  />
</template>
